export type NameType = 'waitForAnimation';

export const name: NameType = 'waitForAnimation';
